// extracted by mini-css-extract-plugin
module.exports = {"messageCol":"Table_messageCol__32NgV","author":"Table_author__3leD8","authorImage":"Table_authorImage__1UTkt","unreadRow":"Table_unreadRow__3EwiQ"};